// QC #45 — `new QueryClient()` tạo client cô lập, invalidate KHÔNG ảnh
// hưởng tới cache app → list không refresh sau khi xóa team. Dùng
// useQueryClient() hook để chia sẻ cache singleton.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosClient } from '@/api/axiosClient';
import { useCallApi } from '@/hooks/useCallApi';
import { MutationOptions } from '@/models';
import { FormDeleteTeamModel } from '@/modules/recruitment-plan/models';
import { fakeNetworkResponse, trans } from '@/utils';

function endpoint() {
  return `/recruitment-plan/delete-team`;
}

export function useDeleteTeam(options?: MutationOptions<boolean, FormDeleteTeamModel>) {
  const { handleCallApi } = useCallApi();
  const queryClient = useQueryClient();
  const deleteMessage = trans('GENERAL.ACTION.DELETE.SUCCESS');

  function handler(form: FormDeleteTeamModel) {
    return handleCallApi(
      async () => {
        await axiosClient.delete(endpoint(), { data: form });
        // Wide-net invalidation — refetch any cached list/detail that
        // references this plan or its data tables.
        queryClient.invalidateQueries({ queryKey: ['recruitment-detail'] });
        queryClient.invalidateQueries({ queryKey: ['recruitment-team-list'] });
        queryClient.invalidateQueries({ queryKey: ['recruitment-org'] });
        queryClient.invalidateQueries({ queryKey: ['filter-worker'] });

        return fakeNetworkResponse(true);
      },
      true,
      deleteMessage
    );
  }

  return useMutation(handler, options);
}
